export default {
  plan: {
    annual: {
      title: '年度计划',
      subtitle: '制定年度经营计划，设定总收入、出租率等核心目标',
      listTitle: '年度计划列表',
      planName: '计划名称',
      planYear: '计划年份',
      orgName: '所属组织',
      orgRequired: '请选择所属组织',
      planStatus: '计划状态',
      totalIncomeTarget: '总收入目标',
      noiTarget: 'NOI目标',
      leaseRateTarget: '出租率目标',
      budgetTotal: '总预算',
      autoCalc: '自动计算',
      preparedBy: '编制人',
      approvedBy: '审批人',
      approvalDate: '审批时间',
      description: '计划描述',
      status: {
        DRAFT: '草稿',
        PENDING_APPROVAL: '待审批',
        APPROVED: '已审批',
        ACTIVE: '执行中',
        COMPLETED: '已完成',
        ADJUSTING: '调整中'
      },
      create: '创建年度计划',
      edit: '编辑年度计划',
      submit: '提交审批',
      approve: '审批',
      activate: '激活执行',
      delete: '删除',
      selectPlaceholder: '选择年度计划',
      submitConfirm: '确认提交审批？',
      activateConfirm: '确认激活执行？激活后将开始计划执行周期。',
      deleteConfirm: '确认删除该计划？',
      detailTab: {
        overview: '概览',
        deptTarget: '部门目标',
        quarterly: '季度计划',
        task: '执行任务',
        kpi: 'KPI监控',
        review: '计划复盘'
      },
      steps: {
        create: '创建计划',
        setTarget: '设置目标',
        splitQuarter: '拆分季度',
        activate: '激活执行',
        monitor: '执行监控',
        complete: '完成复盘'
      },
      summarySource: {
        title: '目标来源明细',
        noTargetHint: '请先在"部门目标"Tab中初始化目标',
        fromIndicator: '来自指标'
      },
      submitValidation: {
        incompleteTitle: '计划内容未完善',
        noTargets: '尚未设置部门目标，请先进入详情页初始化并设置部门目标',
        emptyTargets: '部门目标已创建但未填写年度目标值，请先完善目标数据',
        noQuarters: '尚未拆分季度计划，请先在详情页中拆分季度'
      }
    },
    quarterly: {
      title: '季度执行',
      quarter: '季度',
      planName: '计划名称',
      quarterStatus: '执行状态',
      keyTasks: '关键任务',
      keyRisks: '关键风险',
      responsiblePerson: '负责人',
      status: {
        DRAFT: '草稿',
        ACTIVE: '执行中',
        COMPLETED: '已完成',
        ADJUSTING: '调整中'
      },
      activateBtn: '激活',
      completeBtn: '完成',
      emptyMessage: '暂无季度计划，请先在年度计划中拆分'
    },
    task: {
      title: '执行任务',
      taskName: '任务名称',
      department: '所属部门',
      taskType: '任务类型',
      targetValue: '目标值',
      actualValue: '实际值',
      achievementRate: '达成率',
      deadline: '截止日期',
      assignedTo: '负责人',
      priority: '优先级',
      taskStatus: '任务状态',
      progress: '进度',
      description: '任务描述',
      actualResults: '完成情况',
      status: {
        PENDING: '待开始',
        IN_PROGRESS: '进行中',
        COMPLETED: '已完成',
        CANCELLED: '已取消',
        OVERDUE: '已逾期'
      },
      priorityMap: {
        HIGH: '高',
        NORMAL: '中',
        LOW: '低'
      },
      create: '创建任务',
      edit: '编辑任务',
      start: '开始执行',
      updateProgress: '更新进度',
      complete: '完成任务',
      cancel: '取消任务',
      startConfirm: '确认开始执行？',
      progressPrompt: '请输入当前进度(0-100)',
      progressInputError: '请输入数字',
      completionPrompt: '请输入完成情况',
      cancelConfirm: '确认取消该任务？',
      taskNameRequired: '请输入任务名称'
    },
    indicator: {
      title: '指标管理',
      subtitle: '管理系统KPI指标定义，支持动态扩展',
      indicatorCode: '指标编码',
      indicatorName: '指标名称',
      indicatorNameEn: '英文名称',
      deptCategory: '所属部门类型',
      category: '指标分类',
      unit: '单位',
      calcMode: '计算模式',
      summaryRole: '汇总角色',
      calcExpression: '计算公式',
      dataSource: '数据源',
      sortOrder: '排序号',
      status: '状态',
      create: '新建指标',
      edit: '编辑指标',
      delete: '删除指标',
      codeRequired: '请输入指标编码',
      nameRequired: '请输入指标名称',
      deleteConfirm: '确认删除该指标？',
      summaryRoleMap: {
        NONE: '无',
        TOTAL_INCOME: '总收入',
        NOI: 'NOI',
        LEASE_RATE: '出租率',
        BUDGET: '总预算'
      },
      calcModeMap: {
        AUTO: '自动计算',
        MANUAL: '手动录入',
        HYBRID: '混合模式'
      },
      unitMap: {
        PERCENT: '%',
        YUAN: '元',
        COUNT: '个',
        RATIO: '比率'
      },
      categoryList: '效率,收入,质量,成本'
    },
    kpi: {
      title: 'KPI监控',
      indicatorName: '指标名称',
      targetValue: '目标值',
      actualValue: '实际值',
      achievementRate: '达成率',
      unit: '单位',
      refresh: '刷新KPI',
      trend: '趋势',
      comparison: '对比'
    },
    deptTarget: {
      annualTarget: '年度目标',
      responsiblePerson: '负责人',
      initTargets: '初始化目标',
      initConfirm: '确认初始化？系统将根据指标定义和组织架构生成各部门KPI目标',
      initSuccess: '目标初始化成功',
      editTarget: '编辑KPI目标',
      weight: '权重',
      measurementRule: '考核规则',
      deptName: '所属部门',
      emptyHint: '暂未设置部门目标，请点击"初始化目标"按钮开始',
      q1Target: 'Q1目标',
      q2Target: 'Q2目标',
      q3Target: 'Q3目标',
      q4Target: 'Q4目标',
      decompose: '拆分季度'
    },
    review: {
      title: '计划复盘',
      reviewType: '复盘类型',
      reviewPeriod: '复盘周期',
      reviewDate: '复盘日期',
      summary: '成绩总结',
      issues: '存在问题',
      lessons: '经验教训',
      actionItems: '后续行动',
      score: '综合评分',
      reviewStatus: '状态',
      status: {
        DRAFT: '草稿',
        PUBLISHED: '已发布'
      },
      type: {
        WEEKLY: '周复盘',
        MONTHLY: '月度复盘',
        QUARTERLY: '季度复盘',
        ANNUAL: '年度复盘'
      },
      create: '创建复盘',
      edit: '编辑复盘',
      publish: '发布',
      periodPlaceholder: '如 2026-Q1',
      publishConfirm: '确认发布该复盘记录？发布后不可修改',
      deleteConfirm: '确认删除该复盘记录？'
    },
    adjustment: {
      title: '计划调整',
      adjustmentNo: '编号',
      annualPlan: '年度计划',
      targetIndicator: '调整指标',
      originalValue: '调整前值',
      proposedValue: '建议值',
      adjustmentReason: '调整原因',
      effectiveDate: '生效日期',
      adjustmentStatus: '状态',
      approvalComments: '审批意见',
      status: {
        DRAFT: '草稿',
        PENDING_APPROVAL: '待审批',
        APPROVED: '已通过',
        REJECTED: '已驳回'
      },
      create: '申请调整',
      submit: '提交审批',
      approve: '审批通过',
      reject: '审批驳回',
      submitConfirm: '确认提交审批？',
      approvalPrompt: '请输入审批意见（可选）',
      rejectionPrompt: '请输入驳回原因',
      deleteConfirm: '确认删除该调整申请？',
      targetLabel: '目标'
    },
    dashboard: {
      title: '经营看板',
      overview: '总览',
      alerts: '告警',
      trend: '趋势',
      noData: '暂无数据',
      alertType: '类型',
      alertContent: '告警内容',
      department: '部门',
      alertDate: '日期',
      noAlerts: '暂无告警',
      taskStatusDistribution: '任务状态分布',
      planOverview: '年度计划概览',
      planNameLabel: '计划名称',
      totalIncomeLabel: '总收入目标',
      noiTargetLabel: 'NOI目标',
      leaseRateLabel: '出租率目标',
      noActivePlan: '暂无活跃年度计划',
      alertOverdue: '逾期任务',
      alertKpiLow: 'KPI偏低',
      refreshBtn: '刷新',
      dept: {
        RECRUITMENT: '招商管理',
        OPERATIONS: '营运管理',
        FINANCE: '财务管理'
      }
    },
    report: {
      recruitment: '招商报表',
      operations: '营运报表',
      finance: '财务报表',
      targetVsActual: '目标vs实际对比',
      monthlyTrend: '月度趋势',
      quarterlyComparison: '季度对比',
      annualTarget: '年度目标',
      q1: 'Q1',
      q2: 'Q2',
      q3: 'Q3',
      q4: 'Q4'
    }
  }
}
